import LiveDateAndTime from "../lib/Clock";
import { Headphones, PhoneCall, Sparkles } from "lucide-react";

function Footer() {
  const contactLinks = [
    {
      title: "Support",
      number: "0123456789",
      href: "tel:0123456789",
      icon: Headphones,
      badgeColor: "text-rose-400",
      iconBg: "bg-rose-500/10 border-rose-500/20 group-hover:bg-rose-500/20",
      borderColor: "hover:border-rose-500/40",
      labelColor: "text-rose-300/90",
    },
    {
      title: "Sales",
      number: "03303904240",
      href: "tel:03303904240",
      icon: PhoneCall,
      badgeColor: "text-amber-400",
      iconBg: "bg-amber-400/10 border-amber-400/20 group-hover:bg-amber-400/20",
      borderColor: "hover:border-amber-400/40",
      labelColor: "text-amber-300/90",
    },
    {
      title: "Customer",
      number: "033303904240",
      href: "tel:033303904240",
      icon: Sparkles,
      badgeColor: "text-emerald-400",
      iconBg: "bg-emerald-400/10 border-emerald-400/20 group-hover:bg-emerald-400/20",
      borderColor: "hover:border-emerald-400/40",
      labelColor: "text-emerald-300/90",
    },
  ];

  return (
    <footer className="min-h-9 py-1 px-3 flex items-center justify-center w-full select-none">
      <div className="flex items-center justify-center gap-2 sm:gap-2.5 flex-wrap">
        <LiveDateAndTime />

        {contactLinks.map((item) => {
          const Icon = item.icon;
          return (
            <a
              key={item.title}
              href={item.href}
              className={`group inline-flex items-center gap-1.5 px-2.5 py-1 rounded-xl bg-color2/70 border border-white/10 ${item.borderColor} backdrop-blur-md shadow-sm shadow-black/20 text-[11px] sm:text-xs font-medium transition-all duration-300 hover:scale-[1.02] active:scale-95`}
              title={`Call ${item.title}: ${item.number}`}
            >
              <div
                className={`w-4 h-4 rounded-md flex items-center justify-center border transition-colors ${item.iconBg}`}
              >
                <Icon className={`w-2.5 h-2.5 ${item.badgeColor}`} />
              </div>
              <span className={`font-semibold ${item.labelColor}`}>
                {item.title}:
              </span>
              <span className="text-slate-100 font-mono font-bold tracking-wide group-hover:text-white transition-colors">
                {item.number}
              </span>
            </a>
          );
        })}
      </div>
    </footer>
  );
}

export default Footer;

